// TODO: when this needs to be consumed in Links, copy what we've done for user-groups.ts
// i.e. make this object live in a file in the backend, and serve it to student apps via an API

// Object that captures the hierarchy of filters and the mapping of stored values to the labels rendered on the client
export const LINKS_FILTER_OPTIONS = {
  australia: {
    value: 'AUSTRALIA_GENERAL',
    text: 'General',
    prefix: 'Australia',
    subFilters: {
      international: {
        value: 'AUSTRALIA_INTERNATIONAL',
        text: 'Australia - International',
      },
      domestic: {
        value: 'AUSTRALIA_DOMESTIC',
        text: 'Australia - Domestic',
      },
      clayton: {
        value: 'AUSTRALIA_CLAYTON',
        text: 'Clayton campus',
      },
      caulfield: {
        value: 'AUSTRALIA_CAULFIELD',
        text: 'Caulfield campus',
      },
      parkville: {
        value: 'AUSTRALIA_PARKVILLE',
        text: 'Parkville campus',
      },
      peninsula: {
        value: 'AUSTRALIA_PENINSULA',
        text: 'Peninsula campus',
      },
    },
  },
  malaysia: {
    value: 'MALAYSIA_GENERAL',
    text: 'General',
    prefix: 'Malaysia',
    subFilters: {
      international: {
        value: 'MALAYSIA_INTERNATIONAL',
        text: 'International',
      },
      domestic: {
        value: 'MALAYSIA_DOMESTIC',
        text: 'Domestic',
      },
      campus: {
        value: 'MALAYSIA_CAMPUS',
        text: 'Monash Malaysia campus', // TODO: placeholder name
      },
    },
  },
  indonesia: {
    value: 'INDONESIA_GENERAL',
    text: 'General',
    prefix: 'Indonesia',
    subFilters: {
      international: {
        value: 'INDONESIA_INTERNATIONAL',
        text: 'International',
      },
      domestic: {
        value: 'INDONESIA_DOMESTIC',
        text: 'Domestic',
      },
      campus: {
        value: 'INDONESIA_CAMPUS',
        text: 'Monash Indonesia campus', // TODO: placeholder name
      },
    },
  },
  college: {
    value: 'COLLEGE_GENERAL',
    text: 'General',
    prefix: 'Monash College',
    subFilters: {
      international: {
        value: 'COLLEGE_INTERNATIONAL',
        text: 'International',
      },
      domestic: {
        value: 'COLLEGE_DOMESTIC',
        text: 'Domestic',
      },
      docklands: {
        value: 'COLLEGE_DOCKLANDS',
        text: 'Monash College Docklands', // TODO: placeholder name
      },
    },
  },
  online: {
    value: 'ONLINE_GENERAL',
    text: 'General',
    prefix: 'Monash Online',
  },
};

const getLinksFiltersFullTexts = () => {
  // flatten array so that subfilters are on the same level as parent filters
  const flattenedArr = Object.values(LINKS_FILTER_OPTIONS).reduce(
    (acc, curr) => {
      const { subFilters, prefix } = curr;
      if (subFilters) {
        const subFiltersWithPrefix = Object.values(subFilters).map(
          (subFilter) => {
            return {
              prefix,
              ...subFilter,
            };
          }
        );
        return [...acc, curr, ...subFiltersWithPrefix];
      }
      return [...acc, curr];
    },
    []
  );

  // convert each element into [value, fullText] pairs
  const valueTextPairs = flattenedArr.map(({ value, prefix, text }) => [
    value,
    text.startsWith(`${prefix} - `) ? text : `${prefix} - ${text}`,
  ]);

  // construct value to text mapping
  return Object.fromEntries(valueTextPairs);
};

// Mapping of filter values to text
export const LINKS_FILTER_FULL_TEXT = getLinksFiltersFullTexts();
